export default "__VITE_ASSET__BtuE4VQ2__"